//在这个文件中根路由 / 必须定义，children可自定义
const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    meta: {
      parent: 0,
    },
    children: [
      {
        path: "/xiangQing",
        name: "xiangQing",
        component: _import("home/xiangQing"),
        meta: {
          menuName: "详情结果",
          index: 1, //面包屑顺序
        },
      },
    ],
  },
];
export default routes;
